import { BaseDto } from './base.dto';

export enum AlarmRuleTriggerType {
  CRON = 'cron',
  DEVICE_INPUT = 'device_input',
}

export interface AlarmRuleTriggerDto extends BaseDto {
  alarm_rule_id: number;
  type: AlarmRuleTriggerType;
  config: string | Record<string, unknown> | AlarmRuleTriggerCronConfig | AlarmRuleTriggerDeviceInputConfig;
}

/*
 * Cron Type Entity
 */
export interface AlarmRuleTriggerCronConfig {
  cron: string;
}
/*
 * On Device Input Type Entity
 */
export interface AlarmRuleTriggerDeviceInputConfig {}

export interface AlarmRuleTriggerUpdateDto {
  id?: number;
  type: AlarmRuleTriggerType;
  config: {} | AlarmRuleTriggerCronConfig | AlarmRuleTriggerDeviceInputConfig;
}